// Centralized section metadata used by navigation, side-dots, and the deck
export const SECTIONS = [
  { id: "cover", num: "01", label: "Cover" },
  { id: "story", num: "02", label: "Brand Story" },
  { id: "category", num: "03", label: "Category" },
  { id: "world", num: "04", label: "The World" },
  { id: "extended", num: "05", label: "Extended Collections" },
  { id: "experience", num: "06", label: "Experience" },
  { id: "celebrity", num: "07", label: "In Good Company" },
  { id: "display", num: "08", label: "On The Floor" },
  { id: "partnership", num: "09", label: "Partnership" },
  { id: "global", num: "10", label: "Global" },
  { id: "contact", num: "11", label: "Contact" },
];

export const IMAGES = {
  // Hero product — 24KT gold Ganesha (FINE GOLD 99.99)
  hero: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/gqxvpi5y_AR-WN-013.jpg",
  // Hero secondary — 24KT gold peacock framed artwork (AR-XLP-001, tall portrait, natural cream frame)
  heroPeacock: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/fxxoqspn_AR-XLP-001.png",
  // Brand-story hero — Aarya24KT atelier ritual: applying 24KT gold leaf
  atelier:
    "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/s7orzjvw_A48D25CB-3FBC-4A18-A007-CB9B602D3193.png",
  glassware:
    "https://static.prod-images.emergentagent.com/jobs/86f56886-b9a1-4418-ab1e-fe4dadb02199/images/3c2713498eacc143ff733dcc34262ad4b0d8c44677e1feff1ef4afe8c85adbfe.png",
  // Aarya24KT World — three signature collections (each is a gallery of up to 5)
  worldGoldFoil: [
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/fxxoqspn_AR-XLP-001.png", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/j0m2xzpb_AR-AEEB-008-1.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/qtgiouxr_AR-COMPS-007.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/3zk56vcu_AR-SPG-014.png", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/5nijc8fa_Ganesha.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/v9wdugqi_Layer%201.png", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
  ],
  worldSculpture: [
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/gunihoqr_AR-PWG-311XL.jpg", mode: "clean", cleanOptions: { threshold: 230, soft: 28 } },
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/elbxcd9h_ARM-MFCWC-01M.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/n4dg6bs1_AR-SAT-01M.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/xhqv2oj8_MHK-GSB-1C-1.png", mode: "bleed" },
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/noagst41_AR-PWBA-001J.jpg", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
    { src: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/ev95i8o4_mhk-gmel-01u.png", mode: "clean", cleanOptions: { threshold: 235, soft: 22 } },
  ],
  worldGlassware: [
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/dccwe6rt_VVIOLA%20COLLECTION%202023_06_010386.jpg",
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/9lclmkzr_5-1.png",
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/i99m1w7s_1.jpg",
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/vzwwj91n_5.jpg",
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/22opr3zs_WhatsApp%20Image%202026-05-13%20at%2019.54.36%20%281%29.jpeg",
  ],
  // Founder portrait — Kaivan Shah
  founder:
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/hsu5fz32_20200519_200632.jpg",
  // Celebrity endorsements
  celebMalaika:
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/o3llmq0o_6.jpg",
  celebPM:
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/fbijb23n_WhatsApp%20Image%202024-03-11%20at%202.25.33%20PM.jpeg",
  // Retail display photography
  displayStore:
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/pfnwecdg_WhatsApp%20Image%202024-03-22%20at%2011.21.58%20AM.jpeg",
  displayWall:
    "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/tg4ssy4q_WhatsApp%20Image%202024-03-22%20at%2011.24.26%20AM%20%282%29.jpeg",

  // ── Extended Collections (05) ─────────────────────────────────────────
  // Sacred art — clean white outer bg so frames float seamlessly on the dark deck
  iconsOfFaith: [
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/7xk87y3u_WhatsApp%20Image%202026-08-24%20at%2000.29.23.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "BISMILLAH · FINE GOLD 99.99",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/oe5si0sb_WhatsApp%20Image%202026-08-24%20at%2000.29.24%20%281%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "BISMILLAH · MIHRAB EDITION",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/2an7socl_WhatsApp%20Image%202026-08-24%20at%2000.29.25%20%281%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "MASHALLAH",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/0sspxxv4_WhatsApp%20Image%202026-08-24%20at%2000.29.24.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "MASHALLAH · MOTHER OF PEARL",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/pl7iojyj_WhatsApp%20Image%202026-08-24%20at%2000.29.23%20%281%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "H. KHWAJA GARIB NAWAZ · AJMER SHARIF",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/6stt3byb_WhatsApp%20Image%202026-08-11%20at%2015.57.10.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "MECCA · MEDINA PANORAMA",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/7ujcw639_WhatsApp%20Image%202026-08-11%20at%2016.02.35.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "BISMILLAH · GREEN VELVET",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/fxlk74yz_WhatsApp%20Image%202026-08-11%20at%2016.04.42.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "MECCA · MEDINA · HERITAGE FRAME",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/1w0cwi0e_WhatsApp%20Image%202026-08-11%20at%2016.07.58.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "HARAMAIN · EMERALD NIGHT",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/shb107km_WhatsApp%20Image%202026-08-11%20at%2016.08.27.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "ALLAH · MIHRAB MEDALLION",
    },
  ],
  // Custom commissions — hero product shots on light/white background
  bespokeGifts: [
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/y032xv8x_WhatsApp%20Image%202026-08-24%20at%2000.29.22%20%281%29.jpeg",
      mode: "bleed",
      caption: "ABU DHABI · FINANCE DEPARTMENT",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/99oo3i9f_WhatsApp%20Image%202026-08-24%20at%2000.29.21%20%282%29.jpeg",
      mode: "bleed",
      caption: "GOLD PLATED COMMEMORATIVE COINS",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/zmiopv36_WhatsApp%20Image%202026-08-24%20at%2000.29.21%20%281%29.jpeg",
      mode: "bleed",
      caption: "SHARJAH CHAMBER OF COMMERCE",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/xuvg7e65_WhatsApp%20Image%202026-08-24%20at%2000.29.20.jpeg",
      mode: "bleed",
      caption: "MASDAR BUILDING · ABU DHABI",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/94mu54nw_WhatsApp%20Image%202026-08-24%20at%2000.29.20%20%282%29.jpeg",
      mode: "bleed",
      caption: "GROWTH OF DUBAI · GOVERNMENT COMMISSION",
    },
  ],
  // Gold-framed velvet portraits — clean white outer bg so the frame floats on dark
  dubaiSeries: [
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/778ze4k6_WhatsApp%20Image%202026-08-11%20at%2014.37.18%20%281%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "BURJ AL ARAB",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/u6100sk5_WhatsApp%20Image%202026-08-11%20at%2014.37.18%20%282%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "AL FAHIDI WIND TOWER",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/yvbtupgr_WhatsApp%20Image%202026-08-11%20at%2014.37.18%20%283%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "BURJ KHALIFA",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/l6tvt0hj_WhatsApp%20Image%202026-08-11%20at%2014.37.18%20%284%29.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "DALLAH · ARABIC COFFEE POT",
    },
    {
      src: "https://customer-assets-v7afamib.emergentagent.net/job_529c33f3-05ef-452b-8632-eb5e6489c218/artifacts/ompjlx9y_WhatsApp%20Image%202026-08-11%20at%2014.37.18.jpeg",
      mode: "clean",
      cleanOptions: { threshold: 240, soft: 18 },
      caption: "THE KHANJAR",
    },
  ],
};

// Official Aarya24kt brand assets
export const LOGO = {
  // Primary brand mark — bright metallic gold on solid black (perfect for our deck)
  // Includes registered sub-text "Gold Foil Artwork Collection"
  mark: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/0otl1kr7_Aarya%20logo%20Gold.png",
  // Same logo on white background (for light contexts / PDF cover sheets if needed)
  white: "https://customer-assets.emergentagent.com/job_gold-gifting-studio/artifacts/s9i3dlj8_aarya%20logo%20white.jpg",
};

export const TAGLINE = "World's Largest Gold Foil Gifting Brand";

export const WHATSAPP_URL =
  "https://wa.me/918655061044?text=" +
  encodeURIComponent(
    "Hi, I'm interested in exploring Aarya24KT for my store. Please share more details.",
  );

export const WHATSAPP_PRESENTATION =
  "https://wa.me/918655061044?text=" +
  encodeURIComponent(
    "Hi, I'd like to schedule a call to understand Aarya24KT better. Please share available time slots.",
  );

export const WHATSAPP_CONVERSATION = WHATSAPP_URL;

export const EMAIL = "manika@aarya24kt.com";
export const PHONE = "+91 86550 61044";
export const WEBSITE = "www.aarya24kt.com";
